import { patchSessionMainRunInCache } from './patchSessionMainRunInCache'

/**
 * Updates cached session display title on mainRun.
 *
 * @param {import('@tanstack/react-query').QueryClient} queryClient
 * @param {{ sessionId: string|number, title: string }} params
 */
export function patchSessionTitleInLibraryCache(queryClient, { sessionId, title }) {
  if (title == null) {
    return
  }

  patchSessionMainRunInCache(queryClient, {
    sessionId,
    transform: (prevMainRun) => ({ ...prevMainRun, title }),
  })
}
